import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "@redux/hooks";
import {
  resetOnboardProvider,
  onboardProvider,
} from "@user-management-context/write/application/use-cases/provider-onboarding/onboard-provider";
import { selectProviderOnboarding } from "@user-management-context/write/application/use-cases/provider-onboarding/selectors/provider-onboarding-selectors";
import { useApiAction } from "@shared-kernel/primary/shared/api-errors/use-api-action";
import { applyApiFieldErrors } from "@shared-kernel/primary/shared/api-errors/apply-api-field-errors";
import type { ActionForm } from "@shared-kernel/primary/shared/api-errors/action-form";
import { useResetWhenSettled } from "@shared-kernel/primary/shared/request-state/use-reset-when-settled";
import { POSTAL_ADDRESS_FIELD_RENAMES } from "@shared-kernel/primary/forms/validations/postal-address.schema";
import type { ProviderOnboardingFormInputs } from "./form-validation/full-form.schema";
import { formatFormDataToOnboardProviderBody } from "./form-validation/shared";

export const useProviderOnboarding = (form: ActionForm<ProviderOnboardingFormInputs>) => {
  const navigate = useNavigate();
  const run = useApiAction();
  const { processing } = useAppSelector(selectProviderOnboarding);
  useResetWhenSettled(processing, resetOnboardProvider);

  // L'API dit pourquoi le profil est refusé (adresse incomplète, fichier invalide), sous le champ fautif
  const onboard = useCallback(
    async (values: ProviderOnboardingFormInputs) => {
      const outcome = await run(onboardProvider(formatFormDataToOnboardProviderBody(values)), {
        success: "Votre profil organisation est prêt !",
        failure: "Erreur lors de la finalisation de votre profil organisation",
      });
      if (!outcome.ok) {
        applyApiFieldErrors(form, outcome.error, POSTAL_ADDRESS_FIELD_RENAMES);
        return;
      }
      navigate("/onboarding");
    },
    [run, navigate, form],
  );

  return { onboard };
};
